import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { CustomPopupComponent } from '../../dialogs/custom-popup/custom-popup.component';

@Component({
  selector: 'app-no-account',
  templateUrl: './no-account.component.html',
  styleUrls: ['./no-account.component.sass']
})
export class NoAccountComponent implements OnInit {

  loginForm: FormGroup;
  public selectedLanguageFlag: string = 'es';

  public conditions: boolean = false
  public allowNotifications: boolean = false

  constructor(
    public dataService: DataService,
    public authService: AuthService,
    public firebase: AngularFireAuth,
    private formBuilder: FormBuilder,
    private router: Router,
    private translate: TranslateService,
    private dialog: MatDialog,
    private snackbar: MatSnackBar) { }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({ 
      student_id: new FormControl('', Validators.required),
      name: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      phone: new FormControl('', Validators.required)
    });
  }

  changeLang(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('language', lang);
    this.selectedLanguageFlag = lang
  }

  redirectToWeb() {
    window.location.href = 'https://www.makneticfoto.com/'
  }

  async createAccount() {
    if (!this.conditions) {
      this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant("login.no_accept"), duration: 4000, panelClass: "error-snackbar" })
      return
    }

    if(!this.loginForm.valid) {
      this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant("alerts.form_error"), duration: 4000, panelClass: "error-snackbar" })
      return
    }

    let u = await this.authService.getUser()
    console.log(u)

    if (!u) { 
      let login = await this.authService.anonymousLogin()

      let form = this.loginForm.value

      let sub = this.dataService.createAccount(form['student_id'], form['name'], form['email'], form['phone'], 'family', this.allowNotifications).subscribe((res: any) => {

        if (res.status == 'success'){
          let lang = this.translate.currentLang
    
          this.dataService.resetPasswordFromLogin({ email: form['email'], language: lang }).subscribe(res => {
    
            if (res.status == 'error') {
              switch (this.translate.currentLang) {
                case 'es':
                  this.snackbar.open('No se ha podido enviar el email para establecer contraseña. Vaya al acceso por primera vez en el login.', 'Cerrar')
                  break;
                case 'en':
                  this.snackbar.open('Could not send email to set password. Go to first time access on login', 'Close')
                  break;
                case 'cat':
                  this.snackbar.open("No s'ha pogut enviar el correu electrònic per establir contrasenya. Vagi al accés per primer cop en el login.", 'Cerca')
                  break;
                default:
                  this.snackbar.open('Could not send email to set password. Go to first time access on login', 'Close')
              }
      
            } else {
              switch (this.translate.currentLang) {
                case 'es':
                  this.snackbar.open('Se ha enviado un correo electrónico para establecer su contraseña. Por favor revise su bandeja de entrada.', 'Cerrar')
                  break;
                case 'en':
                  this.snackbar.open('Email has been sent to set password. Please check your inbox.', 'Close')
                  break;
                case 'cat':
                  this.snackbar.open("S'ha enviat un correu electrònic per establir la contrasenya. Comproveu la safata d’entrada.", 'Cerca')
                  break;
                default:
                  this.snackbar.open('Email has been sent to set password. Please check your inbox.', 'Close')
              }
      
            }

            this.router.navigate(['/login'])
      
          })
        }
        else {
          console.log(res.context)
          this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant("alerts.create_account"), duration: 4000, panelClass: "error-snackbar" })
        }

      })
    }
    else {
      //this.router.navigate(['/welcome'])
      console.log("Sesion ya iniciada")
      this.authService.logoutWithoutGoingLogin()
      this.createAccount()
    }
  }
}
